import { render, staticRenderFns } from "./Workspaces_mobile.vue?vue&type=template&id=93320dde&"
import script from "./Workspaces_mobile.vue?vue&type=script&lang=js&"
export * from "./Workspaces_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Workspaces_mobile.vue?vue&type=style&index=0&id=93320dde&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports